/* Aloha Palms - cart rules shown on the cart page and in the cart drawer:
   1) Add-on-only carts: explain and disable checkout until a qualifying food item is in the cart.
   2) $5 orchid lei offer: invite qualifying carts to add an orchid lei (the discount itself is an automatic Shopify discount). */
(function () {
  var PRIMARY_FOOD = [
    'classic-charcuterie-board-best-seller', 'hand-delivered-charcuterie-board-nut-free',
    'hand-delivered-charcuterie-board-vegan', 'hand-delivered-charcuterie-board-gluten-free',
    'custom-charcuterie-board-multiple-dietary-restrictions-accommodated', 'charcuterie-platter-board-or-box',
    'heart-shaped-charcuterie-board', 'fresh-fruit-platters', 'fresh-fruit-cakes',
    'classic-christmas-holiday-boards', 'christmas-tree-board-bundle', '3d-christmas-tree-cone',
    'thanksgiving-charcuterie-boards-pre-order', 'halloween-spooktacular-charcuterie-boards',
    'baby-shower-oh-baby-baptism-charcuterie-board', 'limited-edition-valentine-s-heart-charcuterie-board',
    'letter-number-celebration-boards', 'rainbow-in-a-cup-individually-packed-charcuterie-cup',
    'full-service-grazing-table-catering-oahu-hawaii-aloha-palms-hospitality'
  ];
  // Must match the automatic discount "$5 off Orchid Lei with a Board, Fruit Platter/Cake or Keepsake".
  var LEI_QUALIFIERS = [
    'classic-charcuterie-board-best-seller', 'hand-delivered-charcuterie-board-nut-free',
    'hand-delivered-charcuterie-board-vegan', 'hand-delivered-charcuterie-board-gluten-free',
    'custom-charcuterie-board-multiple-dietary-restrictions-accommodated', 'charcuterie-platter-board-or-box',
    'heart-shaped-charcuterie-board', 'fresh-fruit-platters', 'fresh-fruit-cakes',
    'engraved-keepsake-surfboard', 'lilo-stitch-inspired-engraved-surfboard',
    'mouse-shaped-wooden-keepsake', 'customizable-wooden-board'
  ];
  var ORCHID_LEIS = ['hand-delivered-fresh-leis-purple-flowers', 'hand-delivered-fresh-multi-color-orchid-lei-greetings'];
  var ADDON_PRODUCTS = ['charcuterie-board-add-ons', 'fruit-cake-add-ons', 'utensil-set', 'utensil-set-1'];

  function isRestrictedAddOn(item) {
    if (ADDON_PRODUCTS.indexOf(item.handle) !== -1) return true;
    if (item.handle === 'complete-your-order-add-ons') return /topper|cheese|utensil/i.test(item.variant_title || item.title || '');
    return false;
  }

  var state = { blocked: false, offerLei: false };
  var leiVariant = null;

  function checkoutButtons() {
    return document.querySelectorAll('[name="checkout"], a[href^="/checkout"], .cart__checkout, [data-checkout-button]');
  }

  function blockHtml() {
    return '<p><strong>Add-ons need a main item.</strong></p>' +
      '<p>This item is available as an add-on to an eligible Charcuterie Board, Bundle, Fresh Fruit Platter, or Fresh Fruit Cake. Please add a qualifying item to your cart first.</p>' +
      '<p><a href="/collections/charcuterie-boards">Shop charcuterie boards</a> &middot; <a href="/collections/fresh-fruits">Shop fruit platters &amp; cakes</a></p>';
  }

  function leiHtml() {
    var price = leiVariant ? ' <span class="ap-lei-offer__price"><s>$' + (leiVariant.price / 100).toFixed(0) + '</s> $' + (leiVariant.price / 100 - 5).toFixed(0) + '</span>' : '';
    return '<p><strong>Make their arrival even more special</strong> &mdash; add a fresh orchid lei and receive $5 off.</p>' +
      '<p><button type="button" class="ap-lei-offer__add">Add a Purple Orchid Lei' + price + '</button> ' +
      '<a href="/products/hand-delivered-fresh-multi-color-orchid-lei-greetings">or choose a multicolor orchid lei</a></p>';
  }

  function placeBefore(anchor, cls, html, show) {
    var box = null;
    for (var c = anchor.parentNode.firstElementChild; c; c = c.nextElementSibling) {
      if (c.classList && c.classList.contains(cls)) { box = c; break; }
    }
    if (!box) {
      box = document.createElement('div');
      box.className = cls;
      anchor.parentNode.insertBefore(box, anchor);
    }
    box.style.display = show ? '' : 'none';
    if (show && box.getAttribute('data-ap-html') !== html) { box.innerHTML = html; box.setAttribute('data-ap-html', html); }
    return box;
  }

  function render() {
    // Add-on block, placed just above each checkout button.
    checkoutButtons().forEach(function (btn) {
      if (btn.closest('#apo-modal')) return;
      placeBefore(btn, 'ap-addon-block', blockHtml(), state.blocked);
      if (state.blocked) { btn.setAttribute('disabled', 'disabled'); btn.setAttribute('aria-disabled', 'true'); btn.classList.add('ap-checkout-off'); }
      else if (btn.classList.contains('ap-checkout-off')) { btn.removeAttribute('disabled'); btn.removeAttribute('aria-disabled'); btn.classList.remove('ap-checkout-off'); }
    });
    // Lei offer, placed above the delivery date picker.
    document.querySelectorAll('pickeasy-app-widget').forEach(function (w) {
      var box = placeBefore(w, 'ap-lei-offer', leiHtml(), state.offerLei);
      var b = box.querySelector('.ap-lei-offer__add');
      if (b && !b.getAttribute('data-bound')) {
        b.setAttribute('data-bound', '1');
        b.addEventListener('click', function () {
          if (!leiVariant) return;
          b.disabled = true;
          fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: leiVariant.id, quantity: 1 }] }) })
            .then(function () { window.location.href = '/cart'; })
            .catch(function () { b.disabled = false; });
        });
      }
    });
  }

  function refresh() {
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var hasPrimary = items.some(function (i) { return PRIMARY_FOOD.indexOf(i.handle) !== -1; });
        var hasAddOn = items.some(isRestrictedAddOn);
        var qualifies = items.some(function (i) { return LEI_QUALIFIERS.indexOf(i.handle) !== -1; });
        var hasLei = items.some(function (i) { return ORCHID_LEIS.indexOf(i.handle) !== -1; });
        state.blocked = hasAddOn && !hasPrimary;
        state.offerLei = qualifies && !hasLei;
        render();
      })
      .catch(function () {});
  }

  // Block checkout clicks while add-ons are alone in the cart (runs before other handlers).
  ['click', 'submit'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      if (!state.blocked || !e.target || !e.target.closest) return;
      var t = type === 'submit' ? (e.submitter || e.target) : e.target;
      if (t.closest && t.closest('[name="checkout"], a[href^="/checkout"], .cart__checkout, [data-checkout-button]')) {
        e.preventDefault(); e.stopImmediatePropagation();
      }
    }, true);
  });

  fetch('/products/hand-delivered-fresh-leis-purple-flowers.js')
    .then(function (r) { return r.json(); })
    .then(function (p) { leiVariant = p.variants.filter(function (v) { return v.available; })[0] || null; render(); })
    .catch(function () {});

  var origFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) p.then(function () { setTimeout(refresh, 300); }).catch(function () {});
    return p;
  };

  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    setTimeout(function () { queued = false; render(); }, 250);
  }).observe(document.documentElement, { childList: true, subtree: true });

  var style = document.createElement('style');
  style.textContent =
    '.ap-addon-block{margin:10px 0;padding:12px 14px;border:1px solid #b3261e;border-radius:8px;background:#fdf2f1;color:#5c1612;text-align:left;font-size:14px;line-height:1.45}' +
    '.ap-addon-block p{margin:0 0 6px}.ap-addon-block p:last-child{margin:0}.ap-addon-block a{color:#b3261e;text-decoration:underline}' +
    '.ap-checkout-off{opacity:.5;pointer-events:none !important}' +
    '.ap-lei-offer{margin:12px 0;padding:12px 14px;border:1px solid #8a5aa8;border-radius:8px;background:#f7f1fb;color:#3d2550;text-align:left;font-size:14px;line-height:1.45}' +
    '.ap-lei-offer p{margin:0 0 6px}.ap-lei-offer p:last-child{margin:0}' +
    '.ap-lei-offer__add{border:0;border-radius:999px;background:#6e3f8f;color:#fff;padding:8px 14px;font:inherit;font-size:14px;cursor:pointer}' +
    '.ap-lei-offer__add[disabled]{opacity:.6}.ap-lei-offer a{color:#6e3f8f;text-decoration:underline}' +
    '.ap-lei-offer__price s{opacity:.75;margin-right:2px}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();
